module.exports = __webpack_public_path__ + "img/fin-agent-answer-avatar-dark.fc74803.svg";